<template>
  <b-button
    class="is-link"
    icon-left="print"
    @click="openAllUrls"
    :label="label"
  ></b-button>
</template>

<script>
export default {
  name: 'PrintButton',
  props: {
    label: String,
    urls: Array,
  },
  methods: {
    openAllUrls() {
      if (this.urls.length === 0) return

      // Modern browsers block multiple popups from a single user gesture
      // Best approach: open all URLs synchronously and accept what the browser allows
      // Most browsers will allow 1-2 popups, then block the rest

      let openedCount = 0
      this.urls.forEach((url) => {
        const newWindow = window.open(url, '_blank')
        if (newWindow) {
          openedCount++
        }
      })

      // Inform user if some URLs were blocked
      if (openedCount < this.urls.length) {
        const blockedCount = this.urls.length - openedCount
        console.warn(
          `${blockedCount} URL(s) were blocked by browser popup blocker.`
        )
        console.warn(
          'To open all URLs, please allow popups for this site or click the button multiple times.'
        )

        // Optionally show a user-friendly message (requires Buefy toast)
        if (this.$buefy) {
          this.$buefy.toast.open({
            message: `Opened ${openedCount} of ${this.urls.length} URLs. ${blockedCount} were blocked by popup blocker.`,
            type: 'is-warning',
            duration: 5000,
          })
        }
      }
    },
  },
}
</script>
